// import { apiUrlStatistics } from "~constants";
// import Network from "~helpers/Network";

import { apiUrlStatisticPages } from "~constants";
import Network from "~helpers/Network";

import * as at from "./actionTypes";
import { selectPagesSettingsId } from "./selectors";

export const setStatisticPage = (payload) => ({
  type: at.SET_STATISTIC_PAGE,
  payload,
});

export const setAllStatisticPages = (payload) => ({
  type: at.SET_ALL_STATISTIC_PAGES,
  payload,
});

export const setPagesSettings = (payload) => ({
  type: at.SET_PAGES_SETTINGS,
  payload,
});

export const getStatisticPage = (projectId, id) => (_dispatch, _getState) => {
  const url = `${apiUrlStatisticPages.getPage.format(projectId, id)}`;
  return Network.request(url, {
    loading: true,
    onSuccess: setStatisticPage,
  });
};

export const deleteStatisticPage =
  (projectId, id, options = {}) =>
  (_dispatch, _getState) => {
    const url = `${apiUrlStatisticPages.getPage.format(projectId, id)}`;
    return Network.request(url, {
      method: "DELETE",
      loading: true,
      successMsg: true,
      ...options,
    });
  };

export const createOrUpdateStatisticPage =
  (projectId, data, options = {}) =>
  (_dispatch, _getState) => {
    let url = `${apiUrlStatisticPages.get.format(projectId)}`;
    if (data.id) {
      url += data.id + "/";
    }

    return Network.request(url, {
      method: data.id ? "PUT" : "POST",
      data,
      loading: true,
      successMsg: true,
      ...options,
    });
  };

export const getPagesSettings =
  (projectId, options = {}) =>
  (_dispatch, _getState) => {
    const url = `${apiUrlStatisticPages.getPagesSettings.format(projectId)}`;
    return Network.request(url, {
      loading: true,
      onSuccess: setPagesSettings,
      ...options,
    });
  };

export const updatePages = (projectId, pages) => (_dispatch, _getState) => {
  const settingsId = selectPagesSettingsId(_getState());
  const url = `${apiUrlStatisticPages.updatePages.format(projectId, settingsId)}`;
  return Network.request(url, {
    method: "PUT",
    data: {
      pages,
      settings: {
        // ...pageSettings.settings,
        order: pages,
      },
    },
    loading: true,
    successMsg: true,
  });
};

export const getAllStatisticPages = (projectId) => async (_dispatch, _getState) => {
  const url = `${apiUrlStatisticPages.get.format(projectId)}`;

  const response = await Network.request(url, {
    loading: true,
    params: {
      limit: 99999,
    },
  });
  _dispatch(setAllStatisticPages(response.results || []));

  return response.results || [];
};

export const copyStatisticPage =
  (projectId, id, options = {}) =>
  (_dispatch, _getState) => {
    const url = `${apiUrlStatisticPages.copyPage.format(projectId)}`;
    return Network.request(url, {
      method: "POST",
      data: { page_id: Number(id) },
      loading: true,
      successMsg: true,
      ...options,
    });
  };
